// extracted by mini-css-extract-plugin
export default {"title":"Gemini_title__E0Ua0","subtitle":"Gemini_subtitle__YkA3K","geminiEffectSmall":"Gemini_geminiEffectSmall__b0Nda","geminiEffectBig":"Gemini_geminiEffectBig__fq2kL"};